import setupRouter from '@/router';
import { initKinesis } from '@/plugins/awsKinesis';
import { initAmplitude } from '@/helpers/amplitudeAnalytics';

import MainApp from './App.vue';

if (import.meta.env.DEV) {
  import('@/assets/scss/index.scss');
}

(async () => {
  const pinia = createPinia();
  const app = createApp(MainApp);

  const router = await setupRouter(app);

  const needI18n = router.currentRoute.value.meta.i18nAlias;

  if (needI18n) {
    await import('@/locales/i18n').then((m) =>
      m.setupI18n({
        vueApp: app,
        pageName: router.currentRoute.value.meta.i18nAlias as string,
        router,
      }),
    );
  }

  app.use(pinia);
  app.mount('#app');

  initKinesis();
  initAmplitude();

  // Load Sentry AFTER mount — doesn't block rendering
  if (import.meta.env.VITE_SENTRY_DSN) {
    const { init, browserTracingIntegration, replayIntegration } =
      await import('@sentry/vue');

    init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [
        browserTracingIntegration({ router }),
        replayIntegration({ maskAllText: true, blockAllMedia: true }),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: ['URI malformed'],
    });
  }
})();
